import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import Logo from "./Logo";
import { goToSection } from "@/lib/scroll";

const LINKS = [
  { id: "pour-qui", label: "Pour qui" },
  { id: "pourquoi", label: "Pourquoi" },
  { id: "technologie", label: "Technologie" },
  { id: "deroule", label: "Déroulé" },
  { id: "services", label: "Services" },
  { id: "tarifs", label: "Tarifs" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    goToSection(id);
  };

  return (
    <header
      data-testid="navbar"
      className={`sticky top-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "border-white/10 bg-night/85 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:h-[72px] md:px-8">
        <button data-testid="nav-logo" onClick={() => go("hero")} aria-label="Retour en haut">
          <Logo />
        </button>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-slate-300 transition-colors hover:text-cyan-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+33622857687"
            data-testid="nav-cta-call"
            className="hidden items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm font-medium text-slate-200 transition-colors hover:border-cyan-400/60 hover:text-cyan-300 md:flex"
          >
            <Phone className="h-4 w-4" />
            06 22 85 76 87
          </a>
          <button
            data-testid="nav-cta-availability"
            onClick={() => go("contact")}
            className="hidden rounded-full bg-gradient-to-r from-cyan-400 to-electric px-5 py-2 text-sm font-semibold text-night transition-all duration-300 hover:shadow-[0_0_28px_rgba(34,211,238,0.45)] sm:block"
          >
            Demander une disponibilité
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white lg:hidden"
            aria-label="Menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-b border-white/10 bg-night/95 backdrop-blur-xl lg:hidden">
          <nav className="mx-auto flex max-w-7xl flex-col gap-1 px-5 py-4">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="rounded-lg px-3 py-3 text-left text-base font-medium text-slate-200 transition-colors hover:bg-white/5 hover:text-cyan-300"
              >
                {l.label}
              </button>
            ))}
            <a
              href="tel:+33622857687"
              data-testid="nav-mobile-call"
              className="mt-2 flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-cyan-400 to-electric px-5 py-3 text-sm font-semibold text-night"
            >
              <Phone className="h-4 w-4" />
              Appeler maintenant — 06 22 85 76 87
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}
